import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { APP_CONSTANTS } from '@/constants';
import { StorageUtil } from '@/utils/storage/storageUtil';

interface UIState {
  mobileMenuOpen: boolean;
  sidebarCollapsed: boolean;
  configMode: boolean;
  theme: 'light' | 'dark';
  globalSearch: string;
}

function readSidebarCollapsed(): boolean {
  const stored = StorageUtil.get<boolean>(APP_CONSTANTS.SIDEBAR_KEY);
  return stored === true;
}

const initialState: UIState = {
  mobileMenuOpen: false,
  sidebarCollapsed: readSidebarCollapsed(),
  configMode: false,
  theme: 'light',
  globalSearch: '',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleMobileMenu: (state) => { state.mobileMenuOpen = !state.mobileMenuOpen; },
    setMobileMenuOpen: (state, action: PayloadAction<boolean>) => { state.mobileMenuOpen = action.payload; },
    toggleSidebarCollapsed: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
      StorageUtil.set(APP_CONSTANTS.SIDEBAR_KEY, state.sidebarCollapsed);
    },
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.sidebarCollapsed = action.payload;
      StorageUtil.set(APP_CONSTANTS.SIDEBAR_KEY, action.payload);
    },
    toggleConfigMode: (state) => { state.configMode = !state.configMode; },
    setConfigMode: (state, action: PayloadAction<boolean>) => { state.configMode = action.payload; },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => { state.theme = action.payload; },
    setGlobalSearch: (state, action: PayloadAction<string>) => { state.globalSearch = action.payload; },
  },
});

export const {
  toggleMobileMenu,
  setMobileMenuOpen,
  toggleSidebarCollapsed,
  setSidebarCollapsed,
  toggleConfigMode,
  setConfigMode,
  setTheme,
  setGlobalSearch,
} = uiSlice.actions;
export default uiSlice.reducer;
